export const strings = {
  title: 'Reset User Account',
  body: {
    havingTechnicalIssues:
      'Having technical issues? Resetting will refresh your user status, clear this site’s browsing data, and reload the page.',
    ifYouAreOnACall:
      'If you are on a call, resetting your user account now will end it immediately. Please check before continuing.',
    ifProblemContinues:
      'If the problem continues after resetting, please contact Support through the ',
    helpCenter: 'Help Center.',
  },
  headers: {
    activeCalls: 'Active calls will be disconnected',
    inboxTasks: 'Would you like to keep all inbox tasks?',
  },
  labels: {
    radioButtons: {
      yes: 'Yes, keep my existing tasks',
      no: 'No, clear all my tasks',
      noDescription: 'This includes tasks that were not closed and classified.',
    },
    checkbox: 'I understand that resetting will disconnect my active call(s).',
  },
  footer: {
    primaryText: 'Reset User Account',
    secondaryText: 'Cancel',
  },
  errors: {
    refreshUserStatusFailed:
      'Failed to refresh user status. Please try again or contact support.',
    resetAccountFailed:
      'Failed to reset account. Please try again or contact support.',
  },
} as const;
